import SectionHeading from "@/components/base/SectionHeading";
import { rumorFacts } from "@/mocks/home";

export default function RumorVsFact() {
  return (
    <section id="compare" className="relative w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <SectionHeading
        eyebrow="RUMOR VS FACT"
        title="谣言 × 实锤 对照"
        desc="流传版本和对照结果并排放，疑点在哪、证据是什么，一眼看清。"
        actionLabel="查看更多对照"
        actionHref="#timeline"
      />

      <div className="rounded-lg border border-background-200 overflow-hidden">
        <div className="hidden md:grid grid-cols-2 bg-background-100 border-b border-background-200">
          <div className="px-6 py-3.5 flex items-center gap-2">
            <i className="ri-error-warning-line text-primary-600"></i>
            <span className="font-heading font-bold text-sm text-foreground-950">
              流传的说法
            </span>
          </div>
          <div className="px-6 py-3.5 flex items-center gap-2 border-l border-background-200">
            <i className="ri-shield-check-line text-accent-600"></i>
            <span className="font-heading font-bold text-sm text-foreground-950">
              对照后的结论
            </span>
          </div>
        </div>

        {rumorFacts.map((row, idx) => (
          <div
            key={`${row.rumor}-${idx}`}
            className="grid grid-cols-1 md:grid-cols-2 border-b border-background-100 last:border-0"
          >
            <div className="px-5 md:px-6 py-5 bg-primary-50/50">
              <div className="flex items-start gap-3">
                <span className="shrink-0 mt-0.5 w-6 h-6 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center">
                  <i className="ri-close-line text-sm"></i>
                </span>
                <div>
                  <span className="font-label text-[11px] px-2 py-0.5 rounded bg-primary-100 text-primary-800">
                    {row.tag}
                  </span>
                  <p className="mt-2 text-sm md:text-base text-foreground-900 leading-snug">
                    {row.rumor}
                  </p>
                </div>
              </div>
            </div>

            <div className="px-5 md:px-6 py-5 bg-accent-50/50 md:border-l border-t md:border-t-0 border-background-100">
              <div className="flex items-start gap-3">
                <span className="shrink-0 mt-0.5 w-6 h-6 rounded-md bg-accent-100 text-accent-800 flex items-center justify-center">
                  <i className="ri-check-line text-sm"></i>
                </span>
                <p className="text-sm md:text-base text-foreground-800 leading-relaxed">
                  {row.fact}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}